import { FC } from 'react';
import { repairList, repairStatusMap } from '../../config';
import styles from './index.less';
import { RightOutlined } from '@ant-design/icons';

interface RepairListProps {
  tabsKey: string;
}

const RepairList: FC<RepairListProps> = ({ tabsKey }) => {
  return (
    <div className={styles.container}>
      repairList {tabsKey}
      {repairList.map((item) => (
        <div className={styles.content} key={item.id}>
          <div
            className={styles.tag}
            style={{
              background: repairStatusMap[item.status].backGroundColor,
              color: repairStatusMap[item.status].textColor,
            }}
          >
            <img src={repairStatusMap[item.status].icon} alt="icon" />
            <span>{repairStatusMap[item.status].text}</span>
          </div>
          <div className={styles['content-nav']}>
            <p>{item.title}</p>
            <span>发起时间：{item.createTime}</span>
          </div>
          <div className={styles['content-icon']}>
            <RightOutlined />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RepairList;
